<p-dialog
  [(visible)]="canShowEventPreviewModel"
  [contentStyle]="{ 'max-height': '75vh', width: 'auto', 'z-index': '10030px' }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false"
  [style]="{ width: '80%' }"
  styleClass="preview-modal">
  <ng-template #header>
    <div class="ui-g-11">
      <span>{{ previewTitle }}</span>
    </div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="closePreview()"
      (keypress.enter)="closePreview()"
      tabindex="0">
      <i class="mdl2-cancel close-icon"></i>
    </div>
  </ng-template>

  @if (!hasPreviewDataLoaded) {
    <div class="mh">
      <p-progressSpinner
        strokeWidth="5"
        fill="#EEEEEE"
        animationDuration=".5s"></p-progressSpinner>
    </div>
  }

  @if (hasPreviewDataLoaded) {
    <div>
      <app-preview-content
        [documentRawData]="eventRawData"
        [documentPreviewData]="eventPreviewData">
      </app-preview-content>
    </div>
  }

  <p-dialog
    [(visible)]="invoiceRejectionModalDisplay"
    [contentStyle]="{
      'max-height': '70vh',
      width: 'auto',
      'z-index': '1038px'
    }"
    [closable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="false"
    class="modal-position">
    <ng-template #header>
      <div class="ui-g-11">
        <span>Select reasons to reject the document</span>
      </div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closeDeclineModal()"
        (keypress.enter)="closeDeclineModal()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>

    <app-preview-confirmation-form
      heading="heading 1"
      optionsLabel="Reasons"
      optionsPlaceholder="Select reason for rejecting the invoice"
      [optionsList]="invoiceRejectionList"
      [showTextArea]="hasAdditionalNotesSection"
      textareaLabel="Additional Notes (Optional)"
      textareaPlaceholder="Enter Notes"
      (onConfrimClick)="confirmClick($event)"
      (onCancelClick)="closeDeclineModal()">
    </app-preview-confirmation-form>
  </p-dialog>

  @if (hasPreviewDataLoaded) {
    <div class="ui-g">
      <div class="ui-g-2"></div>
      <div class="ui-g-10">
        @for (message of msgsUsageDetails; track message) {
          <p-message [life]="3000" [text]="message.detail"></p-message>
        }
      </div>
      <div class="ui-g-2"></div>
      <div class="ui-g-1">
        @if (!hideNextPrevious) {
          <input
            class="next-previous"
            [disabled]="!checkForPrevious()"
            (click)="onPreviousClick()"
            type="button"
            value="« Previous" />
        }
      </div>
      <div class="ui-g-8 center">
        @if (showRejectButton) {
          <button
            [disabled]="rejectButtonDisabled"
            type="button"
            pButton
            (click)="onDenyOpen()"
            pTooltip="Reject"
            tooltipPosition="top"
            class="ui-button-info btnpad btnmr button-deny">
            Reject
          </button>
        }
        @if (showApproveButton) {
          <button
            [disabled]="acceptButtonDisabled"
            type="button"
            pButton
            (click)="submitForApproval()"
            pTooltip="Approve"
            tooltipPosition="top"
            class="ui-button-info btnpad btnmr button-approve">
            Approve
          </button>
        }
      </div>
      <div class="ui-g-1">
        @if (!hideNextPrevious) {
          <input
            class="next-previous"
            [disabled]="!checkForNext()"
            (click)="onNextClick()"
            type="button"
            value="Next »" />
        }
      </div>
    </div>
  }

  @if (isApproveReject) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
</p-dialog>
